import { IBackgroundJobStarted } from '@models/backgroundJobs/IBackgroundJob';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { BackgroundJobWaitStore } from '@services/backgroundJobs/awaitBackgroundJob';
import { BackgroundJobAction } from '@services/backgroundJobs/backgroundJobKinds';
import { createBackgroundJobTask } from '@services/backgroundJobs/backgroundJobTask';
import { createSyncLoadFromFileTransport, LoadFromFileTransport } from './loadFromFileTransport';

/**
 * В итоге окна — папка с созданными документами (ссылка итога), но не «Открыть документ»: окно открыто из него же или
 * из меню реестра.
 */
export const loadFromFileResultAction = (action: BackgroundJobAction): boolean => action.type === 'openLink';

export interface IBackgroundTransportDeps {
    store?: BackgroundJobWaitStore;
    start?: (file: File) => Promise<IBackgroundJobStarted>;
    /** Механизм выключен на сервере (404 старта) — загрузка одним запросом. */
    fallback?: LoadFromFileTransport;
}

/**
 * Загрузка фоновой задачей: файл уходит на сервер, задача идёт в очереди, окно следит за ней, пока открыто.
 * Закрытое окно (`signal`) перестаёт следить: задача дорабатывает, итог придёт тостом и уведомлением.
 */
export const createBackgroundLoadFromFileTransport = (
    docId: string,
    actionKey: string,
    {
        store,
        start = (file) => new DocumentExecutionService(docId).startLoadFromFileInBackground(actionKey, file),
        fallback = createSyncLoadFromFileTransport(docId, actionKey),
    }: IBackgroundTransportDeps = {},
): LoadFromFileTransport => {
    return (file, context) =>
        createBackgroundJobTask(() => start(file), {
            kind: 'loadFromFile',
            store,
            fallback: (ctx) => fallback(file, ctx),
            resultActions: loadFromFileResultAction,
        })(context);
};
